import { fromUnixTime } from 'date-fns';
import { cloneDeepWith } from 'lodash';
import moment from 'moment';

/**
 * The Firebase onCall handler cannot stringify some arrays of documents returned by our APIs.
 * To fix this we stringify the results on the backend and parse them on the frontend
 *
 * @deprecated Only old APIs use this format
 */
export function parseAPIJSON_legacy<OutType>(data: { data: OutType }): {
  data: OutType;
} {
  if (typeof data.data === 'string') {
    return { ...data, data: JSON.parse(data.data) };
  }

  return data;
}

export function parseAPISafeJSON<OutType>(data: { data: OutType }): {
  data: OutType;
} {
  return { data: deserialiseAPIObject(data.data) };
}

export function deserialiseAPIObject<T>(obj: T): T {
  return cloneDeepWith(obj, val => {
    if (val === null) return;

    /**
     * If there is a `__datatype__` key then this object needs to be deserialised
     */
    if (val.__datatype__) {
      switch (val.__datatype__) {
        /**
         * Process timestamp types
         */
        case 'timestamp':
          return moment(fromUnixTime(val.value._seconds));
        default:
          console.error(
            `[deserialiseAPIObject] Unknown datatype '${val.__datatype__}'. Data:`,
            val
          );
          throw new Error(
            `[deserialiseAPIObject] Unknown datatype '${val.__datatype__}'`
          );
      }
    }

    return;
  });
}
